import { ReactElement } from 'react';
import { Badge } from '@mui/material';
import LineAwesome from '../LineAwesome/LineAwesome';

export interface DropDownTitleProps {
  iconClass?: string;
  icon?: string;
  className?: string;
  badgeVariant?: string;
  badgeClass?: string;
  badgeValue?: number;
  title: string;
}

const badgeColor = (variant?: string): 'error' | 'success' | 'default' => {
  if (variant === 'danger') {
    return 'error';
  }
  if (variant === 'success') {
    return 'success';
  }
  return 'default';
};

const DropDownTitle = ({
  className = '',
  icon = 'shopping-cart',
  iconClass,
  badgeVariant,
  badgeClass,
  badgeValue,
  title
}: DropDownTitleProps): ReactElement => (
  <div className={className}>
    <Badge
      className={badgeClass}
      color={badgeColor(badgeVariant)}
      badgeContent={badgeValue}
      overlap='rectangular'>
      {icon && <LineAwesome icon={icon} className={iconClass} />}
    </Badge>
    {title && ` ${title}`}
  </div>
);

export default DropDownTitle;
